module.exports = __webpack_public_path__ + "img/stt-done-hover.bb409330.png";